import { BrowserModule } from '@angular/platform-browser';
import { NgModule, NO_ERRORS_SCHEMA, CUSTOM_ELEMENTS_SCHEMA } from '@angular/core';
import { HttpClientModule } from '@angular/common/http';
import { HttpModule } from '@angular/http';
import { HTTP_INTERCEPTORS } from '@angular/common/http';
import { Authinterceptor } from './shared/services/authinterceptor';
import { SidebarModule } from 'ng-sidebar';
import { JwtHelper, AuthHttp } from 'angular2-jwt';
import { ExportAsModule } from 'ngx-export-as';

import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { BuildingsComponent } from './buildings/buildings.component';
import { VendorsComponent } from './vendors/vendors.component';
import { LeadsComponent } from './leads/leads.component';
import { ReportsComponent } from './reports/reports.component';
import { DashboardComponent } from './dashboard/dashboard.component';
import { ShellComponent } from './shell/shell.component';
import { HeaderComponent } from './shell/header/header.component';
import { DataListModule } from 'primeng/primeng';
import { TabMenuModule, DropdownModule } from 'primeng/primeng';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { AuthguardService } from './shared/services/authguard.service';
import { Userservice } from './shared/services/userservice';
import { PhonetypeService } from './shared/services/phonetype.service';

import { CommonModule } from '@angular/common';
import { LoginComponent } from './login/login.component';
import { FormsModule } from '@angular/forms';
import { ReactiveFormsModule } from '@angular/forms';
import { AuthenticationService } from './shared/services/authentication.service';
import { ShowHideContainer } from './login/show-hide-container';
import { CommonService } from './shared/services/common.service';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { NgbTooltipModule } from '@ng-bootstrap/ng-bootstrap';
import { MultiSelectModule, ProgressBarModule, CalendarModule } from 'primeng/primeng';
import { DataTableModule } from 'primeng/primeng';
import { FormControlModule } from '@shared/form-control/form-control.module';
import { SocialPopupModule } from '@shared/modal-popup/social.popup.module';
import { GoogleplaceDirective } from './directives/google-places-api';
import { TypeService } from '@shared/services/type.service';
import { AgmCoreModule } from '@agm/core';
import { MapPopupModule } from '@shared/map-popup/map.popup.module';
import { ClickOutsideDirective } from '../app/shell/header/clickOutside.directive';
import { Ng4LoadingSpinnerModule } from 'ng4-loading-spinner';
import { ChangePassComponent } from './shell/header/change-pass/change-pass.component';
import { UserService } from './shared/services/user/user.service';
import { InfiniteScrollModule } from 'ngx-infinite-scroll';
import { UserlogPopupComponent } from '../app/users/modal-popup/userlog-popup/userlog-popup.component';
import { ManageListsService } from './shared/services/manage-lists.service';
import { ActivityTypeService } from './shared/services/activity-type.service';
import { DatePipe } from '@angular/common';
import { PreviousRouteService } from '@app/shared/services/previous-route.service';
import { UserPrivilegesService } from '@app/shared/services/user-privileges/user-privileges.service';
import { ManageListsComponent } from './manage-lists/manage-lists.component';
import { OpportunityTypeService } from './shared/services/opportunity-type.service';
import { ListUserService } from './shared/services/list-user.service';
import { PobookService } from './shared/services/pobook.service';

// import { SharedModule } from './shared/shared.module';
import { DashboardDetailPopupComponent } from './dashboard/dashboard-detail-popup/dashboard-detail-popup.component';

@NgModule({
  declarations: [
    AppComponent,
    BuildingsComponent,
    VendorsComponent,
    LeadsComponent,
    ReportsComponent,
    DashboardComponent,
    ShellComponent,
    HeaderComponent,
    LoginComponent,
    ShowHideContainer,
    GoogleplaceDirective,
    ClickOutsideDirective,
    ChangePassComponent,
    UserlogPopupComponent,
    ManageListsComponent,
    DashboardDetailPopupComponent
  ],
  imports: [
    BrowserModule,
    AppRoutingModule,
    DataListModule,
    TabMenuModule,
    HttpClientModule,
    HttpModule,
    CommonModule,
    BrowserAnimationsModule,
    FormsModule,
    ReactiveFormsModule,
    SidebarModule,
    MultiSelectModule,
    DataTableModule,
    FormControlModule,
    DropdownModule,
    SocialPopupModule,
    ProgressBarModule,
    CalendarModule,
    NgbModule.forRoot(),
    NgbTooltipModule.forRoot(),
    Ng4LoadingSpinnerModule.forRoot(),
    AgmCoreModule.forRoot({
      apiKey: 'AIzaSyAejgj1DfWqkbpPjnayAK3z-TwX6aERGMc',
      libraries: ['places']
    }),
    MapPopupModule,
    InfiniteScrollModule,
    ExportAsModule,
    // SharedModule
  ],
  exports: [GoogleplaceDirective,
    ClickOutsideDirective],
  providers: [
    PreviousRouteService,
    AuthenticationService,
    AuthguardService,
    TypeService,
    PobookService,
    Userservice,
    UserService,
    PhonetypeService,
    DatePipe,
    JwtHelper,
    AuthHttp,
    AuthenticationService,
    ManageListsService,
    ActivityTypeService,
    CommonService,
    OpportunityTypeService,
    ListUserService,
    TypeService,
    ActivityTypeService,
    UserPrivilegesService, 
    {
      provide: HTTP_INTERCEPTORS,
      useClass: Authinterceptor,
      multi: true
    }],
  bootstrap: [AppComponent],
  schemas: [ CUSTOM_ELEMENTS_SCHEMA, NO_ERRORS_SCHEMA ]
})

export class AppModule { }


// WEBPACK FOOTER //
// ./src/app/app.module.ts